export const GET_TAGS_REQUEST = 'GET_TAGS_REQUEST'
export const GET_TAGS_SUCCESS = 'GET_TAGS_SUCCESS'
export const GET_TAGS_FAILURE = 'GET_TAGS_FAILURE'

export const GET_CATEGORIZED_TAGS_REQUEST = 'GET_CATEGORIZED_TAGS_REQUEST'
export const GET_CATEGORIZED_TAGS_SUCCESS = 'GET_CATEGORIZED_TAGS_SUCCESS'
export const GET_CATEGORIZED_TAGS_FAILURE = 'GET_CATEGORIZED_TAGS_FAILURE'

export const CREATE_TAG_REQUEST = 'CREATE_TAG_REQUEST'
export const CREATE_TAG_SUCCESS = 'CREATE_TAG_SUCCESS'
export const CREATE_TAG_FAILURE = 'CREATE_TAG_FAILURE'

export const GET_TAG_REQUEST = 'GET_TAG_REQUEST'
export const GET_TAG_SUCCESS = 'GET_TAG_SUCCESS'
export const GET_TAG_FAILURE = 'GET_TAG_FAILURE'

export const GET_COMPLIANCE_RATINGS_REQUEST = 'GET_COMPLIANCE_RATINGS_REQUEST'
export const GET_COMPLIANCE_RATINGS_SUCCESS = 'GET_COMPLIANCE_RATINGS_SUCCESS'
export const GET_COMPLIANCE_RATINGS_FAILURE = 'GET_COMPLIANCE_RATINGS_FAILURE'

export const UPDATE_TAG_REQUEST = 'UPDATE_TAG_REQUEST'
export const UPDATE_TAG_SUCCESS = 'UPDATE_TAG_SUCCESS'
export const UPDATE_TAG_FAILURE = 'UPDATE_TAG_FAILURE'

export const GET_TAGS_COMPLIANCE_RATINGS_REQUEST = 'GET_TAGS_COMPLIANCE_RATINGS_REQUEST'
export const GET_TAGS_COMPLIANCE_RATINGS_SUCCESS = 'GET_TAGS_COMPLIANCE_RATINGS_SUCCESS'
export const GET_TAGS_COMPLIANCE_RATINGS_FAILURE = 'GET_TAGS_COMPLIANCE_RATINGS_FAILURE'

export const GET_TAG_MATRIX_REQUEST = 'GET_TAG_MATRIX_REQUEST'
export const GET_TAG_MATRIX_SUCCESS = 'GET_TAG_MATRIX_SUCCESS'
export const GET_TAG_MATRIX_FAILURE = 'GET_TAG_MATRIX_FAILURE'

export const GET_COMPLIANCES_COMPARISON_REQUEST = 'GET_COMPLIANCES_COMPARISON_REQUEST'
export const GET_COMPLIANCES_COMPARISON_SUCCESS = 'GET_COMPLIANCES_COMPARISON_SUCCESS'
export const GET_COMPLIANCES_COMPARISON_FAILURE = 'GET_COMPLIANCES_COMPARISON_FAILURE'


// WEBPACK FOOTER //
// ./src/constants/tags.js